import { Component } from '@angular/core';

@Component({
  selector: 'ds-rg-change-password',
  templateUrl: './rg-change-password.component.html',
  styleUrl: './rg-change-password.component.scss'
})
export class RgChangePasswordComponent {
  currentDate = new Date();
  currentYear = this.currentDate.getFullYear();

  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
}
